import { toType } from '../utils';

function smoothScrollService ($window, viewport) {
    /* your service code should go here */
    return {
        smoothScroll
    };


    function smoothScroll(elementId, duration = 100) {
        const offset = viewport.isAtLeastDesktop() ? 80 : 20;
        const start = self.pageYOffset;
        const stop = _elmYPosition(elementId) - offset;
        const distance = stop - start;
        const startTime = Date.now();

        $window.requestAnimationFrame(scroll);

        function scroll() {
            const percentAnimationComplete = (Date.now() - startTime) / duration;
            if (percentAnimationComplete <= 1) {
                $window.scrollTo(0, start + (percentAnimationComplete * distance));
                $window.requestAnimationFrame(scroll);
            } else {
                $window.scrollTo(0, stop);
            }
        }
    }


    function _elmYPosition(elementId) {
        var elm;
        if (toType(elementId) === 'string') {
            elm = $window.document.getElementById(elementId) || {};
        } else {
            elm = elementId || {};
        }
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != $window.document.body) {
                node = node.offsetParent;
            y += node.offsetTop;
        }
        return angular.isNumber(y) ? y : 0;
    }

    // function defaultOffset() {
    //     return viewport.isAtLeastDesktop() ? 80 : 20;
    // }

}

smoothScrollService.$inject = [
    /* your service dependencies should go here */
    '$window',
    'viewport'
];

export default smoothScrollService;
